export default "__VITE_ASSET__BaBpxw62__"